import { FloorLampDualOutlineIcon } from './FloorLampDualOutlineIcon';

/**
 * author: Michael Irigoyen
 * id E53D8FB5-A010-4EFA-91EB-731E8C6B7321
 * name floor-lamp-dual-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-dual-outline.svg
 * tags
 * - Home Automation 
 */
export const FloorLightDualOutlineIcon = FloorLampDualOutlineIcon;
export default FloorLightDualOutlineIcon